module.exports = __webpack_public_path__ + "1.bundle.worker.js"